function hide(...elements) {
  elements.forEach(element => element.classList.add('hidden'));
}

function show(...elements) {
  elements.forEach(element => element.classList.remove('hidden'));
}

function getCsrfToken() {
  return document.querySelector('meta[name="csrf-token"]').content;
}

export { hide, show, getCsrfToken };
